import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxFormsService } from '../services/ngx-forms.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NgxFormFields } from './ngx-form.interfaces';
export class NgxFormFieldsComponent implements OnChanges {
   form: FormGroup
   formlyFields: FormlyFieldConfig[] = []
   fields: NgxFormFields
   item: any
   action: EventEmitter<any> = new EventEmitter()
/**
 * @param {?} formsService
 */
constructor(private formsService: NgxFormsService) {}
/**
 * @param {?} change
 * @return {?}
 */
ngOnChanges(change) {
    if (change['fields']) {
      this.formlyFields = this.formsService.parseFields(this.fields)
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-form-fields',
  template: `
    <formly-form [model]="item" [fields]="formlyFields" [form]="form"></formly-form>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgxFormsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'form': [{ type: Input },],
'formlyFields': [{ type: Input },],
'fields': [{ type: Input },],
'item': [{ type: Input },],
'action': [{ type: Output },],
};
}

function NgxFormFieldsComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormFieldsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormFieldsComponent.ctorParameters;
/** @type {?} */
NgxFormFieldsComponent.propDecorators;
/** @type {?} */
NgxFormFieldsComponent.prototype.form;
/** @type {?} */
NgxFormFieldsComponent.prototype.formlyFields;
/** @type {?} */
NgxFormFieldsComponent.prototype.fields;
/** @type {?} */
NgxFormFieldsComponent.prototype.item;
/** @type {?} */
NgxFormFieldsComponent.prototype.action;
/** @type {?} */
NgxFormFieldsComponent.prototype.formsService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
